import { createContext } from 'react';

const atributosFichaTecContext = createContext();

export default atributosFichaTecContext;